import { useCallback } from "react";
export function useImageResize() {
    var processImage = useCallback(function (input) {
        return new Promise(function (resolve, reject) {
            var url = new URL("./imageResize.worker.ts", import.meta.url);
            var worker = new Worker(url, { type: "module" });
            worker.onmessage = function (e) {
                worker.terminate();
                if (e.data.success) {
                    resolve(e.data);
                }
                else {
                    reject(new Error(e.data.error));
                }
            };
            worker.onerror = function (err) {
                worker.terminate();
                reject(err);
            };
            worker.postMessage(input);
        });
    }, []);
    return { processImage: processImage };
}
